<template>
  <div></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

const store = useStore();
const route = useRoute();
const form = ref({
  token: route.query.token || "",
  email: route.query.email || "",
});

const VerifyEmail = () => {
  store.dispatch("auth/verifyemail", form.value);
};

onMounted(() => {
  VerifyEmail();
});
</script>
